import "./RideHailingCorner.module.css";
import Header from "@/reusable_sections/Header";
import HeroPojokOjol from "./sections/HeroPojokOjol";
import BreakingDriver from "./sections/BreakingDriver";
import LaporanDriver from "./sections/LaporanDriver";
import InfoRaziaHariIni from "./sections/InfoRaziaHariIni";
import TarifBonus from "./sections/TarifBonus";
import KomunitasDriver from "./sections/KomunitasDriver";
import VideoLiveDriver from "./sections/VideoLiveDriver";
import MobileQuickActions from "./sections/MobileQuickActions";
import GlossyBottomNavigation from "./sections/GlossyBottomNavigation";
import Footer from "@/reusable_sections/Footer";
export default function RideHailingCornerPage() {
  return <div>
      <Header />
      <HeroPojokOjol />
      <BreakingDriver />
      <LaporanDriver />
      <InfoRaziaHariIni />
      <TarifBonus />
      <KomunitasDriver />
      <VideoLiveDriver />
      <MobileQuickActions />
      <GlossyBottomNavigation />
      <Footer />
    </div>;
}